import { HandledGroupState, QuoteHandledState } from './types';

// Highest first: a lane in several states shows as the first match.
export const HANDLED_STATE_PRECEDENCE: QuoteHandledState[] = [
  QuoteHandledState.Replied,
  QuoteHandledState.Quoted,
  QuoteHandledState.Skipped,
  QuoteHandledState.Active,
];

// Display order of the handled groups.
export const HANDLED_GROUP_STATES: HandledGroupState[] = [
  QuoteHandledState.Replied,
  QuoteHandledState.Quoted,
  QuoteHandledState.Skipped,
];

// Label per handled state, used by the group headers.
export const HANDLED_STATE_LABELS: Record<HandledGroupState, string> = {
  [QuoteHandledState.Replied]: 'Replied to',
  [QuoteHandledState.Quoted]: 'Quoted',
  [QuoteHandledState.Skipped]: 'Skipped',
};

// Explanations shown from the completed-suggestion category headers.
export const HANDLED_STATE_EXPLANATIONS: Record<HandledGroupState, string> = {
  [QuoteHandledState.Replied]:
    'A human reply was detected for this request or a linked copy in a teammate’s inbox. Automatic replies do not count.',
  [QuoteHandledState.Quoted]:
    'A quote was completed in Drumkit. Opening the request or getting a quick quote does not mark it as completed.',
  [QuoteHandledState.Skipped]:
    'The request was dismissed or became stale after more than 7 days without a quote or reply.',
};

// Copy shown above the handled groups when no lane on the thread is left to quote.
export const ALL_HANDLED_MESSAGE = 'All quotes on this thread are handled';
